import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { trackATSScoreNavigation } from '../utils/analytics';

interface HeaderProps {
  onRequestDemo: () => void;
}

const Header: React.FC<HeaderProps> = ({ onRequestDemo }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { label: 'About', href: '#about', isRoute: false },
    { label: 'Pricing', href: '#pricing', isRoute: false },
    { label: 'FAQ', href: '#faq', isRoute: false },
  ];

  return (
    <header className='fixed top-0 left-0 right-0 z-50 bg-black transition-all duration-200'>
      <div className="max-w-7xl mx-auto px-6">
        <nav className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-2">
            <img 
              src="/logo.svg" 
              alt="Vertex Find Logo" 
              className="w-8 h-8"
            />
            <span className="text-base font-semibold text-white">
              Vertex Find
            </span>
          </div>

          {/* Desktop Navigation - Centered */}
          <div className="hidden md:flex items-center space-x-1 absolute left-1/2 transform -translate-x-1/2">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white rounded-lg transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
            <Link
              to="/ats-score"
              className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white rounded-lg transition-colors duration-200"
              onClick={() => trackATSScoreNavigation('header')}
            >
              Know Your ATS Score
            </Link>
          </div>

          {/* Desktop CTAs - Right Aligned */}
          {/* <div className="hidden md:flex items-center space-x-3">
            <button className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 transition-colors duration-200">
              Log in
            </button>
            <button onClick={onRequestDemo} className="btn-primary text-sm px-6 py-2.5">
              Sign up →
            </button>
          </div> */}

          {/* Mobile Menu Button */}
          <button
            className="md:hidden relative w-10 h-10 rounded-lg hover:bg-gray-800 flex items-center justify-center transition-colors duration-200"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            <div className="w-5 h-5 flex flex-col justify-center items-center">
              <span className={`block transition-all duration-200 h-0.5 w-5 rounded-full bg-gray-300 ${
                isMobileMenuOpen ? 'rotate-45 translate-y-0.5' : '-translate-y-1'
              }`} />
              <span className={`block transition-all duration-200 h-0.5 w-5 rounded-full bg-gray-300 ${
                isMobileMenuOpen ? 'opacity-0' : 'opacity-100'
              }`} />
              <span className={`block transition-all duration-200 h-0.5 w-5 rounded-full bg-gray-300 ${
                isMobileMenuOpen ? '-rotate-45 -translate-y-0.5' : 'translate-y-1'
              }`} />
            </div>
          </button>
        </nav>

        {/* Mobile Menu */}
        <div className={`md:hidden transition-all duration-300 overflow-hidden ${
          isMobileMenuOpen 
            ? 'max-h-96 opacity-100 pb-4' 
            : 'max-h-0 opacity-0 pb-0'
        }`}>
          <div className="bg-gray-900 rounded-lg p-4 mt-2 border border-gray-800">
            <div className="space-y-1">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="block px-4 py-2 text-sm font-medium text-gray-300 hover:text-white hover:bg-gray-800 rounded-lg transition-colors duration-200"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <Link
                to="/ats-score"
                className="block px-4 py-2 text-sm font-medium text-gray-300 hover:text-white hover:bg-gray-800 rounded-lg transition-colors duration-200"
                onClick={() => {
                  setIsMobileMenuOpen(false);
                  trackATSScoreNavigation('header');
                }}
              >
                Know Your ATS Score
              </Link>
            </div>
            {/* <div className="pt-3 space-y-2 border-t border-gray-200 mt-3">
              <button className="w-full px-4 py-2 text-sm font-medium text-gray-700 hover:bg-white rounded-lg transition-colors duration-200">
                Log in
              </button>
              <button 
                onClick={() => {
                  setIsMobileMenuOpen(false);
                  onRequestDemo();
                }} 
                className="w-full btn-primary text-sm"
              >
                Sign up →
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 